module.exports = __webpack_public_path__ + "static/media/galerija_2013 (19).babae690.jpg";